export default class Shop {

    constructor(bike, color) {
        this.bike = bike;
        this.color = color;
    }

    getShopURL(params) {

        const baseURL = 'https://guardianbikes.com/pages/';

        let shopURL = baseURL;

        if (Number(this.bike.wheel) === 20) {
            if (this.bike.type === 'ethos') {
                shopURL += '20-inch-small-bikes';
            } else if (this.bike.type === 'premium') {
                shopURL += '20-inch-large-bikes';
            }
        } else if (Number(this.bike.wheel) === 24) {
            if (this.bike.color === 'white') {
                shopURL = 'https://www.amazon.com/dp/B06XHF93M7/ref=twister_B07KMZ7ZKJ?_encoding=UTF8&psc=1'
            } else {
                shopURL += '24-inch-bikes'
            }
        } else if (Number(this.bike.wheel) === 16){
            shopURL += '16-inch-bikes';
        } else {
            shopURL = baseURL
        }

        if (params) {
            shopURL += `?${params.partnerKey}=${params.partnerValue}`;
            if (Number(this.bike.wheel) === 24 && this.bike.color === 'white') {
                shopURL = 'https://amzn.to/2QYiBM8'
            }
        }

        return shopURL;
    }

}


// WEBPACK FOOTER //
// ./src/classes/Shop.js